/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon20Solid = forwardRef('ArrowAUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M4.321 9.165a1.25 1.25 0 0 1-1.767-1.768L7.79 2.161a3.125 3.125 0 0 1 4.42 0l5.236 5.236a1.25 1.25 0 0 1-1.767 1.768L11.25 4.737V17.5a1.25 1.25 0 1 1-2.5 0V4.737L4.321 9.165Z" })));
});
